import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-info"
}
const _hoisted_2 = {
  key: 0,
  class: "sel-subtitle-option"
}
const _hoisted_3 = { style: {"font-size":"14px"} }
const _hoisted_4 = { class: "sel-title-option" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sel-title-option" }
const _hoisted_7 = { class: "sel-subtitle-option" }
const _hoisted_8 = {
  key: 1,
  class: "sel-empty-message"
}
const _hoisted_9 = {
  key: 2,
  style: {"height":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.options.length || $props.noOptionsMessage || $props.button)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-selector",
          ref: "contextMenuElem",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {if ($setup.getState() !== 'disabled') {$setup.isShowingContextMenu = !$setup.isShowingContextMenu; $setup.update(); $setup.isFocused = !$setup.isFocused}}),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => ($setup.isMouseOver = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => ($setup.isMouseOver = false)),
          onContextmenu: _cache[4] || (_cache[4] = (e) => e.stopPropagation()),
          style: _normalizeStyle($setup.props.hideBorder ? { border: 'none', gap: '8px' } : {
      border: `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
      borderTop: $setup.selected !== null && $props.emptyMessage ? `none` : `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
      minHeight: $props.options.some(e => e.subtitle) && $setup.props.size != 'small'  ? `72px` : `53px`,
    })
        }, [
          ($setup.selected !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", {
                  class: _normalizeClass($setup.getTitle($setup.selected) && $setup.props.options?.at($setup.selected)?.subtitle ? 'sel-title-option' : 'sel-subtitle-option')
                }, _toDisplayString($setup.getTitle($setup.selected)), 3 /* TEXT, CLASS */),
                ($setup.getSubTitle($setup.selected))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.getSubTitle($setup.selected)), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (($setup.selected !== null) && $setup.labelElem && $props.emptyMessage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "input-before",
                style: _normalizeStyle({
      backgroundColor: `var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
    })
              }, null, 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          (($setup.selected !== null) && $setup.labelElem && $props.emptyMessage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "input-after",
                style: _normalizeStyle({
      backgroundColor: `var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
      width: `calc(100% - ${$setup.labelLeft}px - (var(--semantic-border-radius-default, 7px) * 2) - ${$setup.currentLabelSize}px)`,
    })
              }, null, 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          ($props.emptyMessage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                ref: "labelElem",
                class: _normalizeClass([
        'semantic-typography-body-regular-default',
        'input-field-label',
        {
          'input-field-label-focused': $setup.floatOn || $setup.selected !== null,
          'semantic-typography-body-bold-small': $setup.floatOn
        }
      ]),
                style: _normalizeStyle({
        color: `var(--components-input-${$setup.getState()}-label-color, #6E6979)`,
        left: $setup.labelLeft,
        top: $setup.selected !== null ? `0%` : `50%`,
      })
              }, [
                ($props.icon)
                  ? (_openBlock(), _createBlock($setup["FontAwesomeIcon"], {
                      key: 0,
                      icon: $props.icon
                    }, null, 8 /* PROPS */, ["icon"]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_3, _toDisplayString($props.emptyMessage), 1 /* TEXT */)
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true),
          (!$props.emptyMessage && $setup.selected === null)
            ? (_openBlock(), _createElementBlock("p", {
                key: 4,
                class: "semantic-typography-body-regular-default input-field-label",
                style: _normalizeStyle({
        color: `var(--components-input-${$setup.getState()}-label-color, #6E6979)`,
        left: $setup.labelLeft,
      })
              }, _toDisplayString('Selecionar item'), 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1 /* HOISTED */)),
          _createVNode($setup["FontAwesomeIcon"], {
            class: "arrow-icon",
            style: _normalizeStyle({
        transform: `rotate(${$setup.isShowingContextMenu ? -180 : 0}deg)`,
        color: `var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`
      }),
            icon: $setup.Icons.imported.faChevronDown
          }, null, 8 /* PROPS */, ["style", "icon"]),
          (_openBlock(), _createBlock(_Teleport, {
            to: "body",
            disabled: !$setup.isMobile
          }, [
            _withDirectives(_createElementVNode("div", {
              class: "context-menu",
              style: _normalizeStyle({
          zIndex: $setup.props.zIndex ?? 100000,
          top: $setup.quadrant.isSuperior ? `${$setup.contextMenuElem?.getBoundingClientRect().height}px` : 'unset',
          bottom: $setup.quadrant.isSuperior ? 'unset' : `${$setup.contextMenuElem?.getBoundingClientRect().height}px`,
          left: $setup.quadrant.isLeft ? '0' : 'unset',
          right: $setup.quadrant.isLeft ? 'unset' : '0',
          maxHeight: $setup.maxHeight + 'px',
        })
            }, [
              _createElementVNode("div", {
                class: "options-father",
                style: _normalizeStyle({
            height: $setup.isMobile ? '50vh' : 'unset',
          })
              }, [
                ($props.clearOption && $setup.selected !== null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "option",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('change', $event, null); $setup.selected = null;})
                    }, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString($props.clearOption.title ?? 'Limpar'), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "option",
                    onClick: (e) => {
            _ctx.$emit('change', e, index);
            $setup.selected = index;
          },
                    key: index
                  }, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(option.title), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(option.subtitle), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_5)), [
                    [_vShow, !option.disabled]
                  ])
                }), 128 /* KEYED_FRAGMENT */)),
                (!$props.options.length && $props.noOptionsMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($props.noOptionsMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($props.button && ($props.options.length || $props.noOptionsMessage))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("v-if", true),
                ($props.button)
                  ? (_openBlock(), _createBlock($setup["CommonButton"], {
                      key: 3,
                      onClick: $props.button?.click,
                      icon: $props.button.icon,
                      action: "secondary",
                      type: "outlined",
                      class: "option-button",
                      text: $props.button.text
                    }, null, 8 /* PROPS */, ["onClick", "icon", "text"]))
                  : _createCommentVNode("v-if", true)
              ], 4 /* STYLE */)
            ], 4 /* STYLE */), [
              [_vShow, $setup.isShowingContextMenu]
            ])
          ], 8 /* PROPS */, ["disabled"]))
        ], 36 /* STYLE, NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    ($props.supportingText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "supporting-text",
          style: _normalizeStyle(`color: var(--components-input-${$setup.getState()}-supporting-text-color)`)
        }, _toDisplayString($props.supportingText), 5 /* TEXT, STYLE */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}